/* Project Import will be here */
import { getCategoryMenu } from "../services/common";
import { getErrorObject, normalizeCategoryMenu } from "../utilities/utils";
/* Project Import will be here */

export const types = {
  CATEGORY_MENU_REQUEST: "CategoryMenu/CATEGORY_MENU_REQUEST",
  CATEGORY_MENU_SUCCESS: "CategoryMenu/CATEGORY_MENU_SUCCESS",
  CATEGORY_MENU_FAILURE: "CategoryMenu/CATEGORY_MENU_FAILURE"
};

const initialState = {
  BR: {
    data: {},
    ids: [],
    group: {}
  },
  CAT: {
    data: {},
    ids: [],
    group: {}
  },
  SUCAT: {
    data: {},
    ids: [],
    group: {}
  },
  COMB: ["CAT", "SUCAT"],
  isLoading: false,
  isFetchDataCompleted: false,
  error: null
};

export const categoryMenu = (state = initialState, action) => {
  switch (action.type) {
    case types.CATEGORY_MENU_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case types.CATEGORY_MENU_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isLoading: false,
        isFetchDataCompleted: true
      };
    case types.CATEGORY_MENU_FAILURE:
      return {
        ...initialState,
        error: action.payload.error,
        isFetchDataCompleted: true
      };
    default:
      return state;
  }
};

/* Get the filter menu details Category, Sub Category and Brand information */
export const categoryMenuRequest = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.CATEGORY_MENU_REQUEST });
    try {
      /* Call the DynamicFilter API to fetch the menu details */
      const response = await getCategoryMenu();

      let payload = normalizeCategoryMenu(response.data.Data);
      dispatch({ type: types.CATEGORY_MENU_SUCCESS, payload });
    } 
    catch (error) {
      const { message } = getErrorObject(error);
      
      dispatch({
        type: types.CATEGORY_MENU_FAILURE,
        payload: { error: message }
      });
    }
  };
};